import { render, staticRenderFns } from "./KollelApplication.vue?vue&type=template&id=62fbab98&"
import script from "./KollelApplication.vue?vue&type=script&lang=js&"
export * from "./KollelApplication.vue?vue&type=script&lang=js&"
import style0 from "./KollelApplication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports